import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import './CustomToast.scss';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface Toast {
	id: number;
	type: 'success' | 'error';
	message: string;
}

let toastId = 0;
let addToast: (toast: Toast) => void;

export function showToast(type: 'success' | 'error', message: string) {
	addToast?.({ id: ++toastId, type, message });
}

export const ToastPortal = () => {
	const [toasts, setToasts] = useState<Toast[]>([]);

	useEffect(() => {
		addToast = (toast: Toast) => {
			setToasts((prev) => {
				const alreadyExists = prev.some(
					(t) => t.message === toast.message && t.type === toast.type
				);
				if (alreadyExists) return prev;

				return [...prev, toast];
			});

			setTimeout(() => {
				setToasts((prev) => prev.filter((t) => t.id !== toast.id));
			}, 2000);
		};
	}, []);

	return ReactDOM.createPortal(
		<div className='toast-container'>
			{toasts.map((toast) => (
				<div key={toast.id} className={`toast ${toast.type}`}>
					<span className='toast-icon'>
						{toast.type === 'success' ? <TaskAltIcon /> : <InfoOutlinedIcon />}
					</span>
					{toast.message}
				</div>
			))}
		</div>,
		document.body
	);
};
